import { useState } from 'react'
import { Update_Customer } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { mutate } from 'swr'
import { Books_Listing, Current_User, User_SchoolClasses } from '@graphql/queries'

const useUpdateCustomer = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Update_Customer,
      successMessage,
      errorMessage,
      async () => {
        await mutate(Current_User)
        await mutate(User_SchoolClasses)
        await mutate(Books_Listing)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateCustomer }
